import React from "react";

const CHUNK_RELOAD_SESSION_KEY = "hw_dashboard_chunk_autoreload";

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

const isChunkLoadError = error => {
  if (!error || typeof error !== "object") {
    return false;
  }
  const { name, message } = error;
  if (name === "ChunkLoadError") {
    return true;
  }
  if (typeof message !== "string") {
    return false;
  }
  return (
    /Loading chunk [\w-]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /error loading dynamically imported module/i.test(message)
  );
};

const safeSessionStorage = {
  getItem(key) {
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch {
      /* private mode or disabled storage */
    }
  },
  removeItem(key) {
    try {
      sessionStorage.removeItem(key);
    } catch {
      /* private mode or disabled storage */
    }
  }
};

export const lazyWithRetry = (importFn, retries = 2, delayMs = 750) => {
  const loadWithRetry = attempt => {
    return importFn()
      .then(module => {
        safeSessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);
        return module;
      })
      .catch(error => {
        if (isChunkLoadError(error)) {
          if (!safeSessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY)) {
            safeSessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, "1");
            window.location.reload();
            return new Promise(() => {});
          }
          throw error;
        }

        if (attempt >= retries) {
          throw error;
        }

        return wait(delayMs).then(() => loadWithRetry(attempt + 1));
      });
  };

  return React.lazy(async () => {
    return loadWithRetry(0);
  });
};
